import { createFileRoute } from '@tanstack/react-router';

import { useParcelList } from '@/features/student-management/hooks/useParcelList';
import { BilletInfoModal } from '@/features/student-management/ui/organisms/BilletInfoModal';
import { ParcelTable } from '@/features/student-management/ui/organisms/ParcelTable';
import { ParcelListTemplate } from '@/features/student-management/ui/templates/ParcelListTemplate';
import { Spinner } from '@/shared/ui/atoms';

export const Route = createFileRoute('/_authenticated/persons/payments/plans/$planId/parcels/')({
  component: ParcelListPage,
});

function ParcelListPage() {
  const { planId } = Route.useParams();
  const {
    plan,
    parcels,
    isLoading,
    selectedIds,
    toggleSelection,
    selectAll,
    clearSelection,
    payParcel,
    cancelParcel,
    editParcel,
    renegotiateSelected,
    cancelSelected,
    openSelected,
    generatedBillet,
    clearGeneratedBillet,
  } = useParcelList(Number(planId));

  if (!plan) {
    return (
      <div className="flex items-center justify-center p-xl">
        <Spinner size="md" />
      </div>
    );
  }

  return (
    <>
      <ParcelListTemplate
        planDescription={plan.description}
        studentName={plan.personName}
        courseName={plan.courseName}
        totalValue={plan.totalValue}
        planStatus={plan.status}
      >
        <ParcelTable
          parcels={parcels}
          isLoading={isLoading}
          selectedIds={selectedIds}
          paymentMethod={plan.paymentMethod}
          onToggleSelect={toggleSelection}
          onSelectAll={selectAll}
          onClearSelection={clearSelection}
          onEditParcel={editParcel}
          onPayParcel={payParcel}
          onCancelParcel={cancelParcel}
          onRenegotiateSelected={renegotiateSelected}
          onCancelSelected={cancelSelected}
          onOpenSelected={openSelected}
        />
      </ParcelListTemplate>

      <BilletInfoModal
        billet={generatedBillet?.billet ?? null}
        open={generatedBillet !== null}
        onClose={clearGeneratedBillet}
      />
    </>
  );
}
